exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".profileImg-290e6dcd{display:block;margin:0 auto;position:relative;z-index:1;border:2px solid #FFF}.userCard-08f0f57b{overflow:hidden}.userCard-08f0f57b .displayName-7c54a7f4{margin:5px 10px 0 10px;overflow:hidden;text-overflow:ellipsis}\n", ""]);

// Exports
exports.locals = {
	"profileImg": "profileImg-290e6dcd",
	"userCard": "userCard-08f0f57b",
	"displayName": "displayName-7c54a7f4"
};